class ParsingError extends Error {
  response = '';
  url = '';
  id = '';
  constructor(response: string, url: string) {
    super('Error parsing server response');
    this.message = 'error_parsing_server_response';
    this.url = url;
    this.response = response;
  }
}

export { ParsingError };
